(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trl-promo-popup"]) return;
  try {
    
  if (!customElements.get('trl-promo-popup')) {
    customElements.define('trl-promo-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.editor = this.dataset.editor === 'true';
        this.key = `trl:promo:${this.dataset.theme}:${this.dataset.campaign || 'promotion'}:v1`;
        this.sessionKey = `${this.key}:session`;
        this.querySelector('.trl-promo__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const first = this.querySelector('.trl-promo__close');
          const last = this.querySelector('a');
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.querySelector('a').addEventListener('click', () => this.dialog.close(), options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.target.contains(this)) this.open(true);
        }, options);
        window.addEventListener('pagehide', () => { clearTimeout(this.timer); if (this.dialog.open) this.dialog.close(); }, options);
        if (this.editor) {
          if (this.dataset.editorPreview === 'true') this.timer = setTimeout(() => this.open(true), 300);
          return;
        }
        if (!this.inSchedule() || !this.canShow()) return;
        this.timer = setTimeout(() => this.open(false), Number(this.dataset.delay) * 1000);
      }
      inSchedule() {
        const now = Date.now();
        const start = this.dataset.start.trim();
        const end = this.dataset.end.trim();
        if ((start && !/(Z|[+-]\d{2}:\d{2})$/.test(start)) || (end && !/(Z|[+-]\d{2}:\d{2})$/.test(end))) return false;
        return (!start || Number.isFinite(Date.parse(start)) && now >= Date.parse(start)) && (!end || Number.isFinite(Date.parse(end)) && now < Date.parse(end));
      }
      canShow() {
        try {
          const session = sessionStorage.getItem(this.sessionKey);
          const last = Number(localStorage.getItem(this.key) || 0);
          if (session || !Number.isFinite(last)) return false;
          if (this.dataset.frequency !== 'session' && last && Date.now() - last < Number(this.dataset.days) * 86400000) return false;
          return true;
        } catch { return false; }
      }
      open(preview) {
        if (!this.isConnected || this.dialog.open) return;
        if (!preview && (!this.inSchedule() || !this.canShow())) return;
        const busy = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]:not(.trl-promo), cart-drawer[open], details[open] .cart-drawer')).some(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
        if (document.visibilityState !== 'visible' || busy) return;
        if (!preview) {
          try {
            localStorage.setItem(this.key, String(Date.now()));
            sessionStorage.setItem(this.sessionKey, '1');
          } catch { return; }
        }
        const template = this.querySelector('template');
        if (template) { template.replaceWith(template.content.cloneNode(true)); }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); if (this.dialog?.open) this.dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
